"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "finale-ligure": {
    "6d112e45": [{
      "hkey": "ca03efdc",
      "slug": "finalborgo-monticello-perti",
      "name": "Finalborgo-Monticello-Perti",
      "primary": true,
      "skipSearch": false
    }],
    "finalborgo": [{
      "hkey": "ca03efdc",
      "slug": "finalborgo-monticello-perti",
      "name": "Finalborgo-Monticello-Perti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "890451d0": [{
      "hkey": "26b3b8db",
      "slug": "finale-pia-calvisio",
      "name": "Finale Pia-Calvisio",
      "primary": true,
      "skipSearch": false
    }],
    "finale-pia": [{
      "hkey": "26b3b8db",
      "slug": "finale-pia-calvisio",
      "name": "Finale Pia-Calvisio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;